import React, { useEffect, useState } from "react";
import { fetchReportShelterOccupancy } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterOccupiedMetricState {
  data?: any[];
}

export const ShelterOccupiedMetric = ({ data }: ShelterOccupiedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [occupied, setOccupied] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        const empty = data.filter((item: any) => item.occupant_id !== null).length;
        setOccupied(empty.toString());
        setIsLoading(false);
      } else {
        await getOccupancyData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getOccupancyData = async () => {
    await fetchReportShelterOccupancy()
      .then((res: any) => {
        const data = res[0].data;
        const empty = data.filter((item: any) => item.occupant_id !== null).length;
        setOccupied(empty.toString());
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return <SingleCardMetric title={"Occupied Beds"} total={occupied} isLoading={isLoading} />;
};
